import React, { useState, useEffect } from 'react';
import './ManageUsers.css';
import AuthService from './auth/AuthServices';

const Dashboard = () => {
  const [statsData, setStatsData] = useState({});

  useEffect(() => {
    const checkDefaultData = async () => {
      try {
        const Response = AuthService.get_stats()
          .then(async (res) => {
            if (res.status === 200 || res.status === 201) {
              let data = await res.json()
              setStatsData(data)
            } else {
              console.log(res)
            }
            
          })
        } catch (error) {
            console.error('An error occurred:', error);
      };
    };  
    checkDefaultData();
  }, []);

  return (
    <div className="container">
      <div className='main-container'>
        <h2>Wilkommen im Adminportal</h2>
        <p>Statistik auf einen Blick</p>
        <div className='stats-container'>
            <div className="box">
              <h4>Benutzeranzahl</h4>
              <p>{statsData["user_count"]}</p>
            </div>
            <div className="box">
              <h4>An. aktiver Lizenzen</h4>
              <p>{statsData["count_active_licenses"]}</p>
            </div>
            <div className="box">
              <h4>Vergleiche ak. Monat</h4>
              <p>{statsData["comparisons_month"]}</p>
            </div>
            <div className="box">
              <h4>Vergleiche ak. Jahr</h4>
              <p>{statsData["comparison_year"]}</p>
            </div>
        </div>  
      </div>  
    </div>
  );
};

export default Dashboard;